module.exports = __webpack_public_path__ + "img/horizontal_5_1_9006.440a3f54.png";